module.exports = __webpack_public_path__ + "222e74b1342852e41f4b5ef9e1787906.svg";